
import { sprintf } from 'sprintf-js';

const getRGB = (RGBObject, opacity) => {
  if(!RGBObject) return '#000';

  const rgbArr = [RGBObject.r, RGBObject.g, RGBObject.b];
  if(opacity){
    rgbArr.push(opacity);
  } else if(RGBObject.a) {
    rgbArr.push(RGBObject.a);
    return 'rgba(' + rgbArr.join(',') + ')';
  }

  return 'rgb(' + rgbArr.join(',') + ')';
};

const lerp = (from_val, to_val, t) => {
  return (to_val - from_val) * t + from_val;
}
/**
 * Do a linear interpolation between {@param rgb} and white.
 * @param rgb {int, int, int} From 0-255
 * @param mult { float } 0-1
 */
const multWhite = (rgb, mult) => {

  // Normalize
  let r = rgb.r / 255.;
  let g = rgb.g / 255.;
  let b = rgb.b / 255.;

  // Mult
  r = lerp(r, 1., mult);
  g = lerp(g, 1., mult);
  b = lerp(b, 1., mult);

  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
    a: rgb.a,
  }
};

const multBlack = (rgb, mult) => {

  let r = rgb.r / 255. * mult;
  let g = rgb.g / 255. * mult;
  let b = rgb.b / 255. * mult;

  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
    a: rgb.a,
  }

}

const rgb_to_hex = (color) => {
  return sprintf("#%02x%02x%02x", color.r, color.g, color.b);
}

export { getRGB, rgb_to_hex, multWhite, multBlack };
